import snakecaseKeys from "snakecase-keys";
import { listenFirestoreUserSettingEvent } from "useFirebase/useFireStore";

import {
  blockWorkspaceUser,
  changeStatusWorkspaceUser,
  createWorkspaceUser,
  deleteWorkspaceUser,
  getWorkspaceUser,
  getWorkspaceUserPage,
  loginAsUser,
  onResendingInvitationUser,
  updateWorkspaceUser,
} from "../../services/apis/workspaceUser";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doGetUserSettingEvent = createAsyncThunk(
  "workspaceUser/doGetUserSettingEvent",
  async (params, { dispatch }) => {
    const { userId, workspaceId } = params;
    await listenFirestoreUserSettingEvent(userId, workspaceId, dispatch);
  }
);

export const doCreateWorkspaceUser = createAsyncThunk(
  "workspaceUser/doCreateWorkspaceUser",
  async params => {
    const result = await createWorkspaceUser(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doUpdateWorkspaceUser = createAsyncThunk(
  "workspaceUser/doUpdateWorkspaceUser",
  async params => {
    const result = await updateWorkspaceUser(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doChangeStatusWorkspaceUser = createAsyncThunk(
  "workspaceUser/doChangeStatusWorkspaceUser",
  async params => {
    const result = await changeStatusWorkspaceUser(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doDeleteWorkspaceUser = createAsyncThunk(
  "workspaceUser/doDeleteWorkspaceUser",
  async params => {
    const result = await deleteWorkspaceUser(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doGetWorkspaceUserPage = createAsyncThunk(
  "workspaceUser/doGetWorkspaceUserPage",
  async params => {
    const request = snakecaseKeys(params);
    Object.keys(request).forEach(
      k =>
        (request[k] =
          typeof request[k] == "string"
            ? request[k]
                .trim()
                .replaceAll(/&/g, "&amp;")
                .replaceAll(/>/g, "&gt;")
                .replaceAll(/</g, "&lt;")
                .replaceAll(/"/g, '"')
                .replaceAll(/\\/g, "\\\\")
            : request[k])
    );
    const result = await getWorkspaceUserPage(request);
    if (!result) {
      return;
    }
    return result;
  }
);

export const getWorkspaceUserInfo = createAsyncThunk(
  "workspaceUser/getWorkspaceUserInfo",
  async params => {
    const result = await getWorkspaceUser(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doBlockWorkspaceUser = createAsyncThunk(
  "workspaceUser/doBlockWorkspaceUser",
  async params => {
    const workspaceId = params.workspaceId;
    const userId = params.userId;
    const block = params.block;
    const result = await blockWorkspaceUser(workspaceId, userId, { block });
    if (!result) {
      return;
    }
    return result;
  }
);

export const doLoginAsUser = createAsyncThunk(
  "workspaceUser/doLoginAsUser",
  async params => {
    const workspaceId = params.workspaceId;
    const userId = params.userId;
    const result = await loginAsUser(workspaceId, userId);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doResendingInvitationUser = createAsyncThunk(
  "workspaceUser/doResendingInvitationUser",
  async params => {
    const result = await onResendingInvitationUser(params);
    if (!result) {
      return;
    }
    return result;
  }
);

const initialState = {
  isSaving: false,
  isUpdating: false,
  workspaceUserDetail: {},
};

const slice = createSlice({
  name: "workspaceUser",
  initialState: initialState,
  reducers: {
    setUserSetting: (state, action) => {
      state.workspaceUserDetail = action.payload;
    },
  },
  extraReducers: {
    [doGetWorkspaceUserPage.pending]: state => {
      state.isSaving = true;
    },
    [doGetWorkspaceUserPage.fulfilled]: state => {
      state.isSaving = false;
    },
    [doGetWorkspaceUserPage.rejected]: state => {
      state.isSaving = false;
    },
    [doCreateWorkspaceUser.pending]: state => {
      state.isSaving = true;
    },
    [doCreateWorkspaceUser.fulfilled]: state => {
      state.isSaving = false;
    },
    [doCreateWorkspaceUser.rejected]: state => {
      state.isSaving = false;
    },
    [doUpdateWorkspaceUser.pending]: state => {
      state.isSaving = true;
    },
    [doUpdateWorkspaceUser.fulfilled]: state => {
      state.isSaving = false;
    },
    [doUpdateWorkspaceUser.rejected]: state => {
      state.isSaving = false;
    },
    [doDeleteWorkspaceUser.pending]: state => {
      state.isSaving = true;
    },
    [doDeleteWorkspaceUser.fulfilled]: state => {
      state.isSaving = false;
    },
    [doDeleteWorkspaceUser.rejected]: state => {
      state.isSaving = false;
    },
    [getWorkspaceUserInfo.fulfilled]: (state, action) => {
      state.workspaceUserDetail = action.payload;
    },
    [doBlockWorkspaceUser.pending]: state => {
      state.isUpdating = true;
    },
    [doBlockWorkspaceUser.fulfilled]: state => {
      state.isUpdating = false;
    },
    [doBlockWorkspaceUser.rejected]: state => {
      state.isUpdating = false;
    },
  },
});

const { reducer, actions } = slice;

export const { setUserSetting } = actions;
export default reducer;

export const isSaving = createSelector(
  state => state.workspaceUser.isSaving,
  isSaving => isSaving
);

export const isUpdating = createSelector(
  state => state.workspaceUser.isUpdating,
  isUpdating => isUpdating
);

export const workspaceUserDetail = createSelector(
  state => state.workspaceUser.workspaceUserDetail,
  workspaceUserDetail => workspaceUserDetail
);
